import React from 'react';
import { Check, Minus } from 'lucide-react';

interface BulkCheckboxProps {
  isSelected: boolean;
  onToggle: () => void;
  /** When true, shows blue box with white minus (e.g. "select all" with some selected). */
  isIndeterminate?: boolean;
  className?: string;
}

const BulkCheckbox: React.FC<BulkCheckboxProps> = ({
  isSelected,
  onToggle,
  isIndeterminate = false,
  className = '',
}) => {
  const checked = isSelected || isIndeterminate;
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={isIndeterminate ? 'mixed' : isSelected}
      onClick={onToggle}
      className={`inline-flex items-center justify-center rounded-md w-4 h-4 transition-colors shrink-0 ${className}`}
    >
      {checked ? (
        <span
          className="inline-flex items-center justify-center w-4 h-4 rounded-md bg-primary-500 text-white shadow-sm"
          style={{ boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,0.12)' }}
        >
          {isIndeterminate ? (
            <Minus className="w-2.5 h-2.5" strokeWidth={3} />
          ) : (
            <Check className="w-2.5 h-2.5" strokeWidth={3} />
          )}
        </span>
      ) : (
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-md border-2 border-gray-300 bg-white" />
      )}
    </button>
  );
};

export default BulkCheckbox;
